function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import CustomButtonIcon from './customButtonIcon.js';
import EVENTS from '../../../common/constants/events';
import { GalleryComponent } from '../../galleryComponent';

var CustomButton = /*#__PURE__*/function (_GalleryComponent) {
  _inheritsLoose(CustomButton, _GalleryComponent);

  var _super = _createSuper(CustomButton);

  function CustomButton() {
    return _GalleryComponent.apply(this, arguments) || this;
  }

  var _proto = CustomButton.prototype;

  _proto.render = function render() {
    var _this = this;

    var styleParams = this.props.styleParams;
    var buttonText = styleParams.customButtonText || 'Click here';
    return /*#__PURE__*/React.createElement("div", {
      className: "custom-button-wrapper",
      style: {
        justifyContent: styleParams.galleryHorizontalAlign,
        zIndex: 17
      }
    }, this.props.small ? /*#__PURE__*/React.createElement(CustomButtonIcon, null) : /*#__PURE__*/React.createElement("button", {
      "data-hook": "custom-button-button",
      onClick: function onClick() {
        return _this.props.actions.eventsListener(EVENTS.BUY_NOW_CLICKED, _this.props);
      },
      tabIndex: -1
    }, buttonText, /*#__PURE__*/React.createElement("div", {
      className: "overlay"
    })));
  };

  return CustomButton;
}(GalleryComponent);

export { CustomButton as default };